import React, { useState, useEffect, useRef } from 'react';
import { Form, Spin } from 'antd';
import { useHistory, useLocation } from 'react-router-dom';
import queryString from 'query-string';
import {
  checkConfirmCode,
  setPasswordWithCode,
} from '../../api/auth';
import { NotificationContainer } from '../../layout/Main';
import appStore from '../../store/App';
import { InvitePasswordForm, InvalidCodeScreen } from './components';
import Slider from '../Login/components/Slider';
import s from '../Login/styles.module.scss';

type InviteStatus = 'verifying' | 'verified' | 'expired' | 'no_code';

interface PasswordFormData {
  password: string;
  confirmPassword: string;
}

export default function InviteUser() {
  const [form] = Form.useForm();
  const [status, setStatus] = useState<InviteStatus>('verifying');
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const location = useLocation();
  const cancelledRef = useRef(false);

  const { code } = queryString.parse(location.search);
  const codeStr = typeof code === 'string' ? code : '';

  useEffect(() => {
    cancelledRef.current = false;

    if (!codeStr) {
      setStatus('no_code');
      return;
    }

    checkConfirmCode({ code: codeStr })
      .then(() => {
        if (!cancelledRef.current) setStatus('verified');
      })
      .catch(() => {
        if (!cancelledRef.current) setStatus('expired');
      });

    return () => {
      cancelledRef.current = true;
    };
  }, [codeStr]);

  const onFinish = async (values: PasswordFormData) => {
    setLoading(true);
    try {
      await setPasswordWithCode({
        code: codeStr,
        password: values.password,
      });

      appStore.setNotification({
        type: 'success',
        title: 'Password Set Successfully',
        width: 380,
      });

      history.push('/login');
    } catch (error: any) {
      console.error('Set password error:', error);
      appStore.setNotification({
        type: 'error',
        title: 'Failed to Set Password',
        width: 380,
      });
    } finally {
      setLoading(false);
    }
  };

  const renderContent = () => {
    switch (status) {
      case 'verifying':
        return (
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: '100%',
            }}
          >
            <Spin size="large" />
          </div>
        );

      case 'verified':
        return (
          <InvitePasswordForm
            form={form}
            loading={loading}
            onFinish={onFinish}
          />
        );

      case 'expired':
      case 'no_code':
        return <InvalidCodeScreen code={codeStr} />;
    }
  };

  return (
    <div className={s.root}>
      <div className={s.block} style={{ width: '50%', height: '100vh' }}>
        <Slider />
      </div>
      <div
        className={s.block}
        style={{
          padding: '0 70px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div style={{ width: '452px' }}>{renderContent()}</div>
      </div>
      <NotificationContainer />
    </div>
  );
}
